import React from 'react';
import { Box } from '@mui/material';
import { AddButton } from './ListHeader';
import { ITableConfigurableModules } from '../../types/Itable';
import { ColumnSelectorOption } from '../../uikit/itable/ITable';
import { useUserColumns } from '../../hooks/useUserColumns';
import MoreListActions from './MoreListActions';

interface ListHeaderActionsProps {
  module: ITableConfigurableModules;
  availableColumns: ColumnSelectorOption[];
  isDownloadingCsv?: boolean;
  onDownloadCsv?: () => void;
  onAdd?: () => void;
}

export default function ListHeaderActions({ module, availableColumns, isDownloadingCsv, onDownloadCsv, onAdd }: ListHeaderActionsProps) {
  const columnState = useUserColumns(module);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <MoreListActions
        module={module}
        availableColumns={availableColumns}
        selectedKeys={columnState.userColumns.map((c) => c.key)}
        isDownloadingCsv={isDownloadingCsv}
        onDownloadCsv={onDownloadCsv}
        onChange={(keys) => columnState.onUpdateColumns(keys.map((key) => ({ key })))}
      />

      <AddButton onAdd={onAdd} />
    </Box>
  );
}
